export default __webpack_public_path__ + "static/media/Exclamation_Triangle_Icon.59625dd9.svg";